import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "18",
      height: "23",
      x: "7",
      y: "3.5",
      rx: "2"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M7 9H4.5M7 15H4.5M7 21H4.5" }, null, -1 /* CACHED */),
    _createElementVNode("circle", {
      cx: "16",
      cy: "12",
      r: "3"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M11 21a5 5 0 0 1 10 0" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }